export const SupervisorEnvironment = {
    production: false,
    baseUrl: 'https://eovlastenjaprez.fina.hr/webapi',
    niasRedirectUrl: 'https://eovlastenjaprez.fina.hr/nias-auth',
    niasRedirectErrorUrl: 'https://eovlastenjaprez.fina.hr/nias-error',
    niasLogoutUrl: 'https://eovlastenjaprez.fina.hr/nias-logout'
}